var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_814_10679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.3996 27.6C90.1996 23.3 86.6996 20 82.3996 20H69.9995C69.9995 9 60.9995 0 49.9995 0C38.9995 0 29.9995 9 29.9995 20H17.5995C13.2995 20 9.79955 23.3 9.59955 27.6L6.39955 91.6C6.19955 96.2 9.79955 100 14.3995 100H85.5995C90.1995 100 93.7995 96.2 93.5995 91.6L90.3996 27.6ZM33.9995 20C33.9995 11.2 41.1996 4 49.9995 4C58.7995 4 65.9995 11.2 65.9995 20H33.9995ZM88.4995 94.8C87.6995 95.6 86.6995 96 85.5995 96H14.3995C13.2995 96 12.2995 95.6 11.4995 94.8C10.6995 94 10.2995 92.9 10.3995 91.8L13.5995 27.8C13.6995 25.7 15.4995 24 17.5995 24H29.9995V44C29.9995 45.1 30.8995 46 31.9995 46C33.0995 46 33.9995 45.1 33.9995 44V24H65.9995V44C65.9995 45.1 66.8996 46 67.9995 46C69.0995 46 69.9995 45.1 69.9995 44V24H82.3996C84.4995 24 86.2996 25.7 86.3996 27.8L89.5995 91.8C89.5995 92.9 89.2996 94 88.4995 94.8Z",
    fill: "#A78721"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_814_10679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping_bag.17ab2ac58c3c4ed97e8cf1e2753a6480.svg";
export { ForwardRef as ReactComponent };